import React from 'react';

import { Col, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

import MyRecordProgress from './MyRecordProgress'

const MyRecordSummary = ({ t }) => {
  const { Text } = Typography;

  return (
    <Row className="my-record-summary">
      <Col lg={24} sm={24} className="record-content">
        <MyRecordProgress />
      </Col>
      <div className="record-content-line" />
      <Col lg={24} sm={24} className="record-content-action">
        <Link to={"/portal/myrecords"} >
          <div className="record-link-action">
            <Text>{t('my_record.more_record')}</Text>
            <Text className="right">{">"}</Text>
          </div>
        </Link>
      </Col>
    </Row>
  );
};

export default translate()(MyRecordSummary);
